module.exports = __webpack_public_path__ + "static/logo13-1d7dc83d8846c065723d1e3230507a70.png";